import React, { useState } from "react";

type DatePickerProps = {
  label?: string;
  value?: string;
  onChange: (date: string) => void;
};

const getTodayString = () => {
  const now = new Date();
  const offsetMs = now.getTimezoneOffset() * 60 * 1000;
  return new Date(now.getTime() - offsetMs).toISOString().split("T")[0];
};

const DatePicker: React.FC<DatePickerProps> = ({ label, value, onChange }) => {
  const [selectedDate, setSelectedDate] = useState(value || "");
  const today = getTodayString();

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Clamp manually-typed dates: the max attribute only blocks the calendar UI
    const dateValue = e.target.value > today ? today : e.target.value;
    setSelectedDate(dateValue);
    onChange(dateValue);
  };

  return (
    <div className="flex flex-col space-y-2">
      {label && (
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </label>
      )}
      <input
        type="date"
        value={selectedDate}
        max={today}
        onChange={handleDateChange}
        className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-600 bg-white dark:bg-[#111B21] text-gray-900 dark:text-white"
      />
    </div>
  );
};

export default DatePicker;
